import { useEffect, useState } from "react";
import { Form, Button, Row, Container, Card, Col } from "react-bootstrap";
import { GenericForm } from "../../Component/GenericForm/GenericForm";
import { Api } from "../../Helpers/axios/axios";
import { formInterface } from "../../Component/GenericForm/formInterface";
import { useNavigate } from "react-router-dom";
import { setAuthCookie, getCookie } from "../../Helpers/cookie/cookieUtils";
import { LoadingSpinner } from "../../Component/Spinner/LoadingSpinner";
import { PUBLIC_URL } from "../../Helpers/config/config";
import "./LogIn.css";

const LogIn = ({ user }: any) => {
  const navigate = useNavigate();

  const config: formInterface[] = [
    { type: "text", name: "User Name", md: 12, key: "email", require: true, placeholder: "Enter your username" },
    { type: "password", name: "Password", md: 12, require: true, key: "password", placeholder: "Enter your password" },
  ];

  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const auth = getCookie();
    if (auth && auth.token) {
      navigate("/home");
    }
  }, [navigate]);

  const Submit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res: any = await Api.logIn(data);
      setAuthCookie({ token: res });
      navigate("/DashBoard");
    } catch (e: any) {
      console.error("Login failed:", e);
      alert(e?.message || "Login failed please check your credentials");
    } finally {
      setLoading(false);
    }
  };

  const onChange = (key: string, value: any) => {
    setData((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div className="login-page-container">
      {loading && <LoadingSpinner overlay text="Authenticating..." />}

      {/* Decorative background shapes */}
      <div className="floating-shape shape-1"></div>
      <div className="floating-shape shape-2"></div>

      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={5}>
            <Card className="login-card border-0">
              <Card.Body className="p-5">
                <div className="text-center">
                  <h1 className="login-title"><img src={PUBLIC_URL + "/images/logo.svg"} alt="chitkara" width={200} height={70} /></h1>
                  <span className="login-subtitle">Please enter your details to sign in</span>
                </div>

                <Form onSubmit={Submit} className="mt-4">
                  <Row>
                    {GenericForm(config, onChange, data)}
                  </Row>

                  <Button className="w-100 mt-4 professional-submit-btn" type="submit" disabled={loading}>
                    {loading ? "Please wait..." : "Sign In"}
                  </Button>
                </Form>

                <div className="text-center mt-4">
                  {/* <p className="text-muted small">
                    © {new Date().getFullYear()} Codebrigade. All rights reserved.
                  </p> */}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export const SignIn = LogIn;